import { ROUTES } from "pages/expenses/constants";

export const SETTINGS_PATHNAME = `/expenses${ROUTES.SETTINGS}`;
export const PROJECTS_PATHNAME = `/expenses${ROUTES.PROJECTS}`;
export const CATEGORIES_PATHNAME = `/expenses${ROUTES.CATEGORIES}`;
export const SUBMISSION_REQUIREMENTS_PATHNAME = `/expenses${ROUTES.SUBMISSION_REQUIREMENTS}`;
